import Cookies from 'js-cookie'
import {
  ErrorData,
  ErrorResponse,
  ResponseData,
  SuccessResponse
} from '../types/serviceTypes'

const API_URL: string = import.meta.env.VITE_API_URL as string

async function fetchMultiPart<T>(
  url: string,
  formData: FormData
): Promise<ResponseData<T>> {
  const jwt = Cookies.get('jwt')
  try {
    const options: RequestInit = {
      method: 'POST',
      body: formData,
      headers: {
        // 'Content-Type': 'multipart/form-data', // we will be sending JSON
        'X-Auth-Token': jwt!
      }
    }

    const response = await fetch(API_URL + '/api' + url, options)
    const result = (await response.json()) as unknown

    if (response.status >= 200 && response.status < 300) {
      return {
        data: result as T,
        status: response.status,
        success: true
      } as SuccessResponse<T>
    }

    return {
      data: result as ErrorData,
      status: response.status,
      success: false
    } as ErrorResponse
  } catch (error) {
    console.error(error)
    return {
      data: error as ErrorData,
      status: 500,
      success: false
    } as ErrorResponse
  }
}

export default fetchMultiPart
